// TODO update this for NCAA Tournament (March Madness) in march
export default [
  {
    name: "Round 1",
    startDate: "2025-03-16T00:00:00",
    endDate: "2025-03-21T23:59:59",
  },
  {
    name: "Round 2",
    startDate: "2025-03-22T00:00:00",
    endDate: "2025-03-23T23:59:59",
  },
  {
    name: "Sweet 16",
    startDate: "2025-03-27T00:00:00",
    endDate: "2025-03-28T23:59:59",
  },
  {
    name: "Elite 8",
    startDate: "2025-03-29T00:00:00",
    endDate: "2025-04-30T23:59:59",
  },
  {
    name: "Final Four",
    startDate: "2025-04-05T00:00:00",
    endDate: "2025-04-05T23:59:59",
  },
  {
    name: "Championship",
    startDate: "2025-04-07T00:00:00",
    endDate: "2025-04-07T23:59:59",
  },
];
